import React from 'react';
import { Fieldset, FormNumber, FormRadio } from '~/components/FormControl';
import { Form } from 'react-bootstrap';

function Others() {
    return (
        <Fieldset className={'px-2'}>
            <Fieldset.Legend>Others</Fieldset.Legend>
            <Form.Row>
                <FormNumber
                    name="healthToRegenerate"
                    sm={4}
                />
                <FormNumber
                    name="extraCritChance"
                    sm={4}
                />
                <FormRadio
                    name="canPreviewMapCard"
                    sm={4}
                />
            </Form.Row>
        </Fieldset>
    );
}

export default Others;
